










































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {ConnectionType, ConnectionTypeMetadata} from '@/model/network/connection/ConnectionType';
import {Profile} from '@/model/network/profile/Profile';

import {INetworkDeviceService} from '@/services/network/INetworkDeviceService';

import NetworkDevicesStore from '@/store/network/NetworkDevices.store';

import NetworkIpSettingsEditor from '@/components/Networking/Profile/NetworkIpSettingsEditor.vue';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {NetworkIpSettingsEditor},
})
export default class NetworkProfileEditor extends Mixins<BaseComponent>(BaseComponent) {

  @Prop()
  public profile!: Profile;

  @Inject(Symbol.for('INetworkDeviceService'))
  private deviceService!: INetworkDeviceService;

  private devicesStore: NetworkDevicesStore = getModule(NetworkDevicesStore, this.$store);

  private ConnectionTypeMetadata = ConnectionTypeMetadata;

  private availableConnectionTypes: ConnectionType[] = [
    ConnectionType.Ethernet,
    ConnectionType.Bridge,
    ConnectionType.Vpn,
  ];

  private async mounted() {
    try {
      this.logger.debug(`Recovering devices list...`);
      await this.devicesStore.fetchDevices();
      this.logger.info(`Devices list fetched`, this.devicesStore.Devices);
    } catch (error) {
      Notify.Error(this.logger, `Could not recover interfaces list`, error);
    }
  }
}
